import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

const AboutPage = () => {
  return (
    <div className='page'>
      <Helmet>
        <title>About Data Beautifier - Free Online Data Transformation Tools</title>
        <meta name="description" content="Learn about Data Beautifier, our mission to provide free, easy-to-use tools for developers and analysts, including JSON, XML, and HTML formatters." />
        <link rel="canonical" href="https://databeautifier.com/about" />
        <meta property="og:title" content="About Data Beautifier" />
      </Helmet>
      <Header />
      {/* Start Page Title Area */}
      <div className="page-title-area">
        <div className="container">
          <div className="page-title-content">
            <h2>About Data Beautifier</h2>
            <ul>
              <li><a href="/">Home</a></li>
              <li className="active">About Us</li>
            </ul>
          </div>
        </div>
      </div>
      {/* End Page Title Area */}

      {/* Start Sample Page Area */}
      <div className="entry-content" data-aos="fade-up" data-aos-duration="2000">
        <div className="container-fluid">
          <h6>Key features of our company</h6>

          <p>Welcome! We're group of people, and software engineers with a love for processing data in various format. Our journey started back in 2007, and over the years, We've had the pleasure of exploring and growing in the world of modern technology like API, React, React JS, Nest and Node etc.</p>

          <p>Driven by curiosity and a passion for data conversion and processing, We've worked on most of the API based project and everywhere we got the data either in JSON or XML format. Whether it's where it's crusial to process those data and convert them to desire format., We're always excited to learn and push the boundaries of what's possible.</p>

          <p>Beyond our professional life, We're deeply passionate about learning new technology and developing online tools which can helps other developers to do their task easily, effectivaly. We believe that "creativity thrives in collaboration" or "curiosity fuels growth", and We aim to live that out every day—whether through our work or in our everyday adventures.</p>

          <p>Feel free to explore our site.</p>
        </div>
      </div>
      <Footer />
      {/* End Sample Page Area */}
    </div>
  );
};
export default AboutPage;